export default __webpack_public_path__ + "73781a6a9712bdc5a0bb738d695b7238.svg";